import { render, staticRenderFns } from "./ModuloDeAutorizacao.vue?vue&type=template&id=21a0e46c&"
import script from "./ModuloDeAutorizacao.vue?vue&type=script&lang=js&"
export * from "./ModuloDeAutorizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports